// extracted by mini-css-extract-plugin
module.exports = {"pricing":"Pricing_pricing__vPNxT","container":"Pricing_container__lkQOX"};